module.exports = __webpack_public_path__ + "img/FeedXpress.7372ec75.png";